import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminReporteriaPage } from "@/features/admin-reporteria/components/AdminReporteriaPage";
import { configsAdminQueryOptions } from "@/features/admin-reporteria/hooks/use-admin-reporteria";

/** Ruta `/admin/reporteria` · gestor de configuraciones de reportería (§8.2). */
export const Route = createFileRoute("/_authed-tw/admin/reporteria")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(configsAdminQueryOptions),
  component: () => (
    <PermissionGate permisos={[PERMISOS.reporteriaAdministrar]}>
      <AdminReporteriaPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
